import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Share } from './Icons/shareIcons';


const Header = ({ project, shareWidgetOpen, onNavIconClick, onShareIconClick }) => {
  const { headerLogo, headerLogoMobile, headerText } = project.templateOptions;
  let logoBlock = headerLogo ? (
    <Link to="/">
      <img src={headerLogo} className="header-logo" alt={project.name} />
    </Link>
  ) : null;
  if (headerLogo && headerLogoMobile) {
    logoBlock = (
      <Link to="/">
        <img src={headerLogoMobile} className="header-logo d-lg-none" alt={project.name} />
        <img src={headerLogo} className="header-logo d-none d-lg-block" alt={project.name} />
      </Link>
    );
  }
  return (
    <header className="header-main d-flex">
      <div className="main-nav-toggle" onClick={onNavIconClick}>
        <span />
        <span />
        <span />
      </div>
      <div className="pr-3">
        {logoBlock}
      </div>
      {headerText ? (
        <Link to="/" className="header-title d-none d-lg-block">
          <h1>{headerText}</h1>
        </Link>
      ) : null}
      <div className={`share-toggle${shareWidgetOpen ? ' active' : ''}`} onClick={onShareIconClick}>
        {shareWidgetOpen ? <span>&times;</span> : <div><Share /><span className="share-toggle-text">Share</span></div>}
      </div>
    </header>
  );
};

Header.propTypes = {
  project: PropTypes.object,
  shareWidgetOpen: PropTypes.bool,
  onNavIconClick: PropTypes.func,
  onShareIconClick: PropTypes.func,
};

Header.defaultProps = {
  onNavIconClick: () => {},
  onShareIconClick: () => {},
};

export default Header;



// WEBPACK FOOTER //
// ./src/components/Header.js